import { useState } from "react";
import { Link } from "react-router-dom";
import { communityFeed } from "@/mocks/artistData";

const editorPicks = [
  {
    ...communityFeed[1],
    editorNote: "JUNO의 칼군무를 완벽하게 재현한 안무 영상. AI 기술로 아이돌 퍼포먼스를 이렇게 생생하게 표현할 수 있다는 걸 보여준 작품.",
    rank: 1,
    category: "K-POP",
    categoryColor: "#ff6eb4",
  },
  {
    ...communityFeed[2],
    editorNote: "블루문 드라마의 클라이맥스 신을 섬세하게 재현. 배우들의 감정 연기와 세트 분위기를 AI로 완벽하게 살려낸 수작.",
    rank: 2,
    category: "드라마",
    categoryColor: "#3d9be9",
  },
  {
    ...communityFeed[4],
    editorNote: "NOVA 웹툰 캐릭터를 실사 영상으로 살려낸 놀라운 작품. 웹툰 특유의 컬러풀한 감성이 영상에 그대로 담겨 있어 팬들의 극찬을 받았다.",
    rank: 3,
    category: "웹툰",
    categoryColor: "#ff8c42",
  },
];

export default function EditorChoice() {
  const [activeIdx, setActiveIdx] = useState(0);
  const active = editorPicks[activeIdx];

  return (
    <section className="py-20 px-6 bg-[#0a0a0f]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex items-end justify-between mb-12">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gradient-to-r from-[#ff6eb4] to-[#ffd60a]">
                <i className="ri-award-fill text-white text-xs" />
              </span>
              <span className="text-[#ff6eb4] text-xs font-semibold tracking-widest uppercase">Editor&apos;s Choice</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight">
              이번 주 에디터가 선택한<br />
              <span className="bg-gradient-to-r from-[#ff6eb4] via-[#3d9be9] to-[#ff8c42] bg-clip-text text-transparent">최고의 팬 제작 창작물</span>
            </h2>
          </div>
          <Link
            to="/community"
            className="hidden md:flex items-center gap-2 text-white/50 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            전체 보기 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Main Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
          {/* Featured Large Card */}
          <div className="lg:col-span-3 relative rounded-2xl overflow-hidden group cursor-pointer">
            <div className="relative w-full h-[380px] md:h-[500px]">
              <img
                src={active.thumbnail}
                alt={active.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />

              {/* Editor Badge */}
              <div className="absolute top-4 left-4 flex items-center gap-2 bg-black/60 backdrop-blur-sm rounded-full px-3 py-1.5 border border-white/10">
                <i className="ri-award-fill text-[#ffd60a] text-sm" />
                <span className="text-white text-xs font-semibold">Editor&apos;s Pick #{active.rank}</span>
              </div>

              {/* Category + Quest Type Badge */}
              <div className="absolute top-4 right-4 flex items-center gap-1.5">
                <span
                  className="text-[10px] font-bold px-2 py-0.5 rounded-full"
                  style={{ background: `${active.categoryColor}25`, color: active.categoryColor, border: `1px solid ${active.categoryColor}40` }}
                >
                  {active.category}
                </span>
                <div className="flex items-center gap-1.5 bg-black/60 backdrop-blur-sm rounded-full px-3 py-1.5 border border-white/10">
                  <i className="ri-film-line text-[#ff6eb4] text-xs" />
                  <span className="text-white text-xs">{active.questTag}</span>
                </div>
              </div>

              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm border border-white/30">
                  <i className="ri-play-fill text-white text-2xl ml-1" />
                </div>
              </div>

              {/* Bottom Info */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2">
                  <img src={active.user.avatar} alt={active.user.name} className="w-7 h-7 rounded-full object-cover object-top border border-white/20" />
                  <span className="text-white/70 text-xs">{active.user.name}</span>
                  <span className="text-[#ff6eb4] text-xs bg-[#ff6eb4]/10 px-2 py-0.5 rounded-full">{active.user.badge}</span>
                </div>
                <h3 className="text-white font-bold text-lg mb-1">{active.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed line-clamp-2">{active.editorNote}</p>
                <div className="flex items-center gap-4 mt-3">
                  <span className="flex items-center gap-1 text-white/50 text-xs">
                    <i className="ri-heart-line" /> {active.likes.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1 text-white/50 text-xs">
                    <i className="ri-chat-1-line" /> {active.comments}
                  </span>
                  <span className="flex items-center gap-1 text-white/50 text-xs">
                    <i className="ri-share-line" /> {active.shares}
                  </span>
                  <span className="text-white/30 text-xs ml-auto">{active.timeAgo}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Side List */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            {editorPicks.map((pick, idx) => (
              <button
                key={pick.id}
                onClick={() => setActiveIdx(idx)}
                className={`relative rounded-xl overflow-hidden text-left transition-all duration-300 cursor-pointer ${
                  activeIdx === idx ? "ring-2 ring-[#ff6eb4]/60" : "opacity-70 hover:opacity-100"
                }`}
              >
                <div className="flex gap-3 p-3 bg-white/5 hover:bg-white/8 transition-colors">
                  <div className="relative w-24 h-16 flex-shrink-0 rounded-lg overflow-hidden">
                    <img src={pick.thumbnail} alt={pick.title} className="w-full h-full object-cover object-top" />
                    <div className="absolute inset-0 bg-black/30" />
                    <span className="absolute top-1 left-1 text-[#ffd60a] text-xs font-bold">#{pick.rank}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1.5 mb-1">
                      <span
                        className="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                        style={{ background: `${pick.categoryColor}20`, color: pick.categoryColor }}
                      >
                        {pick.category}
                      </span>
                    </div>
                    <p className="text-white text-sm font-semibold line-clamp-1 mb-1">{pick.title}</p>
                    <p className="text-white/50 text-xs line-clamp-2 leading-relaxed">{pick.editorNote}</p>
                    <div className="flex items-center gap-3 mt-1.5">
                      <span className="flex items-center gap-1 text-white/40 text-xs">
                        <i className="ri-heart-line text-xs" /> {pick.likes.toLocaleString()}
                      </span>
                      <span className="text-white/30 text-xs">{pick.timeAgo}</span>
                    </div>
                  </div>
                </div>
                {activeIdx === idx && (
                  <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#ff6eb4] to-[#ff8c42]" />
                )}
              </button>
            ))}

            {/* CTA */}
            <Link
              to="/community"
              className="mt-2 flex items-center justify-center gap-2 py-3 rounded-xl border border-white/10 text-white/60 hover:text-white hover:border-white/30 text-sm transition-all cursor-pointer"
            >
              <i className="ri-play-circle-line" />
              커뮤니티에서 더 보기
            </Link>


          </div>
        </div>
      </div>
    </section>
  );
}
